module.exports = __webpack_public_path__ + "img/bingocloud.2130287f.svg";